import * as Yup from "yup";

export const affiliateLevelDiscountValidation = Yup.object().shape({
  name: Yup.string()
    .required("وارد کردن نام تخفیف الزامی است"),
    percent: Yup.string()
    .required("وارد کردن درصد تخفیف الزامی است"),
    minPrice: Yup.string()
    .required("وارد کردن کف قیمت الزامی است"),
    maxPrice: Yup.string()
    .required("وارد کردن سقف قیمت الزامی است"),
});
